// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 创建邀请链接 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /invite-url/create */
export async function inviteUrlCreateUsingPOST(
  body: API.CreateInviteUrlReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/invite-url/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
